import React from 'react';
import { ArrowRight } from 'lucide-react';

const MAP = [
  {
    agency: 'Facebook / Instagram Ad Management',
    sgv: 'Pre-written, AI-personalized Facebook and Instagram ads with guided launch instructions — Phase 1 of every campaign.',
  },
  {
    agency: 'Google Ads for Your Trade',
    sgv: 'Trade-specific Google Search ad copy, ready to launch, with your campaign name and tracking link prefilled.',
  },
  {
    agency: 'CRM Automation & Lead Follow-Up',
    sgv: 'Tracking Package with booking notes that tie every job back to its campaign, plus follow-up email and SMS assets in every campaign — with the Review, Referral and Retention engine on the way.',
  },
  {
    agency: 'Exclusive, Non-Shared Leads',
    sgv: "Every lead comes from YOUR OWN campaign. There's no shared lead pool to worry about — because you're not buying leads from a third party.",
  },
  {
    agency: 'Call-Handling Scripts / Pre-Qualification',
    sgv: 'A CSR Script is included in every campaign, plus Tech, Sales, Financing, Review and Referral scripts — with the Lead Handling Score module coming to spot where calls fall through.',
  },
  {
    agency: 'Done-For-You Landing Pages / Funnels',
    sgv: 'Landing Page Copy in every campaign plus the Offer Selector — personalized to your business, your offer, your city.',
  },
];

export const AgencyReplacementMap = () => (
  <div data-testid="agency-replacement-map">
    <h3 className="text-white font-bold text-xl mb-1">The Agency Replacement Map</h3>
    <p className="text-sm text-gray mb-4">
      A typical home-service marketing agency retainer ($5,000–$20,000+/month) bundles six services. Here's where each one already lives inside GritClicks.
    </p>
    <div className="rounded-xl border border-divider overflow-hidden">
      <div className="grid grid-cols-2 bg-black px-5 py-3 border-b border-divider">
        <p className="text-xs font-black uppercase tracking-wide text-orange">What Agencies Charge For</p>
        <p className="text-xs font-black uppercase tracking-wide text-lime pl-6">What's Already Built Into GritClicks</p>
      </div>
      {MAP.map((row, i) => (
        <div
          key={row.agency}
          data-testid={`agency-map-row-${i}`}
          className={`grid grid-cols-2 px-5 py-4 items-start gap-2 ${i % 2 ? 'bg-black' : 'bg-card-bg'} ${i < MAP.length - 1 ? 'border-b border-divider' : ''}`}
        >
          <p className="text-sm text-white font-semibold pr-4">{row.agency}</p>
          <div className="flex gap-2 pl-6">
            <ArrowRight size={14} className="text-lime shrink-0 mt-0.5" />
            <p className="text-sm text-light-gray leading-relaxed">{row.sgv}</p>
          </div>
        </div>
      ))}
    </div>
    <p className="text-sm text-white font-semibold mt-4 italic" data-testid="agency-map-closer">
      The difference isn't whether these things get done — it's who does the clicking, and what you pay for it.
    </p>
  </div>
);
